export default "__VITE_PUBLIC_ASSET__d34b54c7__"